const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_BASE_URL;

  if (envUrl) {
    return envUrl.replace(/\/$/, "");
  }

  if (typeof window !== "undefined") {
    const { protocol, hostname } = window.location;

    if (hostname === "search.shipcube.com") {
      return "https://searchapi.shipcube.com";
    }

    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:5000";
    }

    return `${protocol}//${hostname}:5000`;
  }

  return "http://localhost:5000";
};

export const API_BASE_URL = getApiBaseUrl();

export const buildApiUrl = (path = "") => {
  if (!path) {
    return API_BASE_URL;
  }

  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

export const buildAssetUrl = (path = "") => {
  if (!path) {
    return "";
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return buildApiUrl(path);
};

export const formatList = (value = "") =>
  value
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
